import { styled } from "@mui/system";
import { Box } from "@mui/material";
import themeCreator from "@Themes/themeCreator";

const customTheme = themeCreator();

const ReactTableStyles = styled(Box)(({ theme, tableHeight, enableHorizontalScroll }) => ({
  marginRight: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",


  "& .filtersWrapper": {
    display: "flex",
    width: "100%",
  },
  ".toolbarLeftObject": {
    padding: `${theme.spacing(0, 5, 0, 0)}`,
  },
  ".toolbarRightObject": {
    marginLeft: "auto",
  },
  ".searchButton": {
    transform: "translateX(calc(100% - 550px))",
    zIndex: "1401",
  },
  ".toolbarButton": {
    color: customTheme.palette.secondary.main,
  },
  "& .overrideRoot": {
    border: "none",
    maxHeight: "69vh",
    ...(enableHorizontalScroll
      ? {
          overflowX: "auto",
        }
      : {}),
  },
  "& .overrideRoot .overrideCell": {
    border: "none",
    color: customTheme.palette.primary.dark,
  },
  "& .overrideRoot .overrideCell:first-child": {
    paddingLeft: theme.spacing(2),
  },

  "& .overrideRoot .MuiDataGrid-main": {
    backgroundColor: customTheme.palette.datagrid.main,
  },
  "& .overrideRoot .columnHeaderOverride": {
    backgroundColor: customTheme.palette.datagrid.odd,
    fontWeight: "900",  // Bolder font
    fontSize: "18px",  // Larger font size
    color: customTheme.palette.primary.main,
  },
  "& .overrideRow.Mui-odd": {
    backgroundColor: customTheme.palette.datagrid.odd,
    fontSize: "16px",  // Larger font size
  },
  "& .overrideRow.Mui-even": {
    backgroundColor: customTheme.palette.datagrid.even,
    fontSize: "16px",  // Larger font size
  },
  '& .tableHeight': {
    maxHeight: tableHeight, // default Height = 69vh
    '&.md': {
      maxHeight: "60vh",
    }
  },
  '& .overrideVirtualScroller': {
    minHeight: theme.spacing(3.75),
  },
  "& .overrideRoot .MuiDataGrid-main": enableHorizontalScroll
    ? {
        overflowX: "auto",
      }
    : {},
  "& .overrideRoot .MuiDataGrid-virtualScroller": enableHorizontalScroll
    ? {
        overflowX: "auto",
      }
    : {},
  "& .overrideRoot .MuiDataGrid-columnHeaders": enableHorizontalScroll
    ? {
        minWidth: "max-content",
      }
    : {},
  "& .overrideRoot .MuiDataGrid-row": enableHorizontalScroll
    ? {
        minWidth: "max-content",
      }
    : {},
  // Add your transform override here.
  "& .MuiPaper-root.MuiDataGrid-paper": {
    transform: "rotate(45deg) !important",
  },
}));

export default ReactTableStyles;
